<template>
    <section class="our-mobile">
        <div class="wrap">
            <h2 class="size-40-700 our-mobile__title text-center"> {{ title }} </h2>
            <p class="our-mobile__description text-center"> {{ description }} </p>
            <div class="our-mobile__img-wrap">
                <img class="our-mobile__img" :src="getImg" :alt="img">
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "ourMobileApplication",
    props: {
        data: Object,
        srcImg: String,
    },
    data() {
        return {
            defaultValue: {
                "title": {
                    "en": "Our Mobile Applications",
                    "es": "Our Mobile Applications",
                    "pt": "Our Mobile Applications"
                },
                "description": {
                    "en": "Stay connected with Mobile Apps: Seamless management, instant notifications, and a user-friendly interface at your fingertips.",
                    "es": "Stay connected with Mobile Apps: Seamless management, instant notifications, and a user-friendly interface at your fingertips.",
                    "pt": "Stay connected with Mobile Apps: Seamless management, instant notifications, and a user-friendly interface at your fingertips."
                },
                "img": "big-aour-mobile-app"
            }
        }
    },
    computed: {
        content() {
            return this.data || this.defaultValue
        },
        lang() {
            return this.$i18n.locale
        },
        title() {
            return this.content.title[this.lang]
        },
        description() {
            return  this.content.description[this.lang]
        },
        img() {
            return this.content.img
        },
        getImg() {
            let pathImg = this.content?.pathImg || this.srcImg || 'other/';
            return require('@/assets/'+pathImg+this.img+'.png');
        },
    }
}
</script>

<style scoped lang="scss">
.our-mobile {
    padding-top: 50px;
    background: #FAFBFD;
    .text-center {
        text-align: center;
    }
    &__title {
        margin-bottom: 15px;
    }
    &__description {
        margin-bottom: 30px;
    }
    &__img-wrap {
        display: flex;
        justify-content: center;
    }
    &__img {
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
    }
}

</style>